/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module basic-styles/cite/citeediting
 */

import { Plugin } from 'ckeditor5/src/core';
import AttributeCommand from '../attributecommand';

const CITE = 'cite';

/**
 * The cite editing feature.
 *
 * It registers the `'cite'` command, the <kbd>Ctrl+I</kbd> keystroke and introduces the `cite` attribute in the model
 * which renders to the view as an `<i>` element.
 *
 * @extends module:core/plugin~Plugin
 */
export default class CiteEditing extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'CiteEditing';
	}

	/**
	 * @inheritDoc
	 */
	init() {
		const editor = this.editor;

		// Allow cite attribute on text nodes.
		editor.model.schema.extend( '$text', { allowAttributes: CITE } );
		editor.model.schema.setAttributeProperties( CITE, {
			isFormatting: true,
			copyOnEnter: true
		} );

		editor.conversion.attributeToElement( {
			model: CITE,
			view: 'cite'
		} );

		// Create cite command.
		editor.commands.add( CITE, new AttributeCommand( editor, CITE ) );

		// Set the Ctrl+T keystroke.
		editor.keystrokes.set( 'CTRL+T', CITE );
	}
}
